import { createSelector } from 'redux-orm';

import orm from '../orm';
import { pathSelector } from './path';
import { isLocalId } from '../utils/local-id';

export const makeSiteByIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ Site }, id) => {
      const siteModel = Site.withId(id);

      if (!siteModel) {
        return siteModel;
      }

      return siteModel.ref;
    },
  );

export const currentSiteSelector = createSelector(
  orm,
  (state) => pathSelector(state).siteId,
  ({ Site }, id) => {
    if (!id) {
      return id;
    }

    const siteModel = Site.withId(id);

    if (!siteModel) {
      return siteModel;
    }

    return siteModel.ref;
  },
);

export const labelsForCurrentSiteSelector = createSelector(
  orm,
  (state) => pathSelector(state).siteId,
  ({ Site }, id) => {
    if (!id) {
      return id;
    }

    const siteModel = Site.withId(id);

    if (!siteModel) {
      return siteModel;
    }

    return siteModel.labels.toRefArray().map((label) => ({
      ...label,
      isPersisted: !isLocalId(label.id),
    }));
  },
);

export const lineIdsForCurrentSiteSelector = createSelector(
  orm,
  (state) => pathSelector(state).siteId,
  ({ Site }, id) => {
    if (!id) {
      return id;
    }

    const siteModel = Site.withId(id);

    if (!siteModel) {
      return siteModel;
    }

    return siteModel
      .getOrderedLinesQuerySet()
      .toRefArray()
      .map((line) => line.id);
  },
);

export const filterUsersForCurrentSiteSelector = createSelector(
  orm,
  (state) => pathSelector(state).siteId,
  ({ Site }, id) => {
    if (!id) {
      return id;
    }

    const siteModel = Site.withId(id);

    if (!siteModel) {
      return siteModel;
    }

    return siteModel.filterUsers.toRefArray();
  },
);

export const filterLabelsForCurrentSiteSelector = createSelector(
  orm,
  (state) => pathSelector(state).siteId,
  ({ Site }, id) => {
    if (!id) {
      return id;
    }

    const siteModel = Site.withId(id);

    if (!siteModel) {
      return siteModel;
    }

    return siteModel.filterLabels.toRefArray();
  },
);

export const siteByIdSelector = makeSiteByIdSelector();
